export default function Marquee({ text }) {
  const row = (text || "").repeat(6);
  return (
    <div className="relative border-y border-royal/20 bg-navy/80 py-4 overflow-hidden" data-testid="marquee" aria-hidden="true">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((i) => (
          <span key={i} className="font-mono text-xs tracking-[0.3em] uppercase text-sky/80 pr-8">
            {row}
          </span>
        ))}
      </div>
    </div>
  );
}
